import React from 'react';


function StandardsAlignmentAndPrinciples() {
  const mappingData = [
    {
      standard: "FOUND-HITL-1.0: Human-in-the-Loop Control",
      oecd: "Principle 1.1: Human-centric values and fairness (Human oversight)",
      iso: "ISO/IEC 42001 (AIMS): Human Oversight Controls"
    },
    {
      standard: "FOUND-ACCT-1.0: AI Outcome Accountability",
      oecd: "Principle 1.5: Accountability",
      iso: "ISO 9001: Leadership and Commitment"
    },
    {
      standard: "OPER-READ-1.0: AI Workflow Readiness",
      oecd: "Principle 1.4: Robustness, security and safety",
      iso: "ISO 31000: Risk Management Guidelines"
    },
    {
      standard: "OPER-PERF-1.0: AI Lead Handling Performance",
      oecd: "Principle 1.2: Transparency and explainability (Metrics)",
      iso: "ISO/IEC 25010: Performance Efficiency"
    },
    {
      standard: "METH-ROI-1.0: AI Automation ROI",
      oecd: "Principle 1.2: Transparency (Economic assessment)",
      iso: "ISO 55000: Asset Management (Value realization)"
    }
  ];

  return (
    <>

      <div className="max-w-5xl mx-auto py-8 px-6">
        <h1 className="text-2xl font-bold text-[#102A43] mb-8 border-b border-gray-200 pb-4">Standards Alignment and Principles</h1>

        <div className="text-sm text-gray-800 leading-relaxed space-y-8">
          <section>
            <p>
              The AI Accountability Standards Council (AASC) develops technical standards that references established international frameworks for artificial intelligence governance and quality management. While AASC standards are independent, specific methodologies, they are designed to draw from high-level principles found in global accords.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">Reference to OECD AI Principles</h2>
            <p>
              AASC standards draw from the OECD AI Principles by translating high-level policy goals into concrete, measurable agency workflows. Where the OECD references "Accountability" (Principle 1.5), AASC defines the specific audit logs that can demonstrate it. Where OECD references "Transparency" (Principle 1.2), AASC defines the reporting formats for performance metrics. This ensures that agencies adopting AASC standards are practically implementing the spirit of the OECD framework.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">Alignment to ISO Management System Concepts</h2>
            <p>
              AASC standards incorporate core concepts from the ISO management system family, specifically the Plan-Do-Check-Act (PDCA) cycle inherent in ISO 9001 (Quality Management) and ISO/IEC 42001 (AI Management Systems). Our declaration requirements emphasize process repeatability, document control, and evidence-based decision making, mirroring the structural rigor of ISO standards but adapted specifically for agile organization using AI environments.
            </p>
          </section>

          <section className="bg-[#F9FAFB] border-l-4 border-gray-400 p-6">
            <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">Important Clarification</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li><strong>Reference does NOT constitute endorsement:</strong> The OECD and ISO do not endorse AASC standards, nor do these references constitute recognition or declaration by those bodies.</li>
              <li><strong>Interpretation:</strong> Mappings provided here represent the Council's interpretation of alignment and are non-authoritative.</li>
              <li><strong>No Mutual Recognition:</strong> AASC accountability declaration is not a substitute for ISO declaration.</li>
              <li><strong>Not Regulatory Approval:</strong> Alignment with these principles does not guarantee compliance with the EU AI Act or other regulations.</li>
              <li><strong>Independent Methodology:</strong> AASC standards are independent methodologies that may exceed or differ from other frameworks in specific technical details.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#102A43] mb-4 uppercase tracking-wide">Standards Mapping Table</h2>
            <div className="overflow-x-auto border border-[#E2E8F0]">
              <table className="w-full text-left text-sm">
                <thead>
                  <tr className="bg-gray-100 border-b border-[#E2E8F0]">
                    <th className="px-4 py-3 font-semibold text-[#102A43] w-1/3">AASC Standard</th>
                    <th className="px-4 py-3 font-semibold text-[#102A43] w-1/3">OECD AI Principles Reference</th>
                    <th className="px-4 py-3 font-semibold text-[#102A43] w-1/3">ISO Management System Concepts</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {mappingData.map((row, index) => (
                    <tr key={index} className="hover:bg-[#F9FAFB]">
                      <td className="px-4 py-3 text-[#102A43] font-medium">{row.standard}</td>
                      <td className="px-4 py-3 text-[#64748B]">{row.oecd}</td>
                      <td className="px-4 py-3 text-[#64748B]">{row.iso}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">Standards Independence</h2>
            <p>
              The AI Accountability Standards Council develops its standards independently. While we review and respect international frameworks to ensure interoperability and philosophical consistency, AASC standards are proprietary methodologies. They are designed to solve the specific problem of measuring agency performance and are not derivative works of any other standards body.
            </p>
          </section>

          <div className="pt-8 border-t border-gray-200 mt-8">
            <p className="text-xs text-gray-500 font-medium">
              declaration status must always be verified through the official Standards Registry at <a href="/registry" className="text-[#2F80ED] hover:underline">/registry</a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default StandardsAlignmentAndPrinciples;